//  IMPORTANT:
//  This file is generated. Your changes will be lost.
//  Source Table: [dbo].[CustomRichTextType]

export enum CustomRichTextTypeEnum {
  PlatformOverview = 1,
  Disclaimer = 2,
  Homepage = 3,
  Help = 4,
  LabelsAndDefinitionsList = 5,
  Training = 6,
  CustomPages = 7
}
